<template>
  <tr class="hours-row">
    <td>
      <div class="inputs-bar">
        <input-field
          class="time-name"
          :placeholder="$t('Time of the day')"
          v-model="text"
          :errors="text_errorsIfTouched"
          maxlength="33"
        />
        <span class="time-range">
          <input-field
            type="time"
            :placeholder="$t('From')"
            v-model="fromTime"
            :errors="fromTime_errorsIfTouched"
          />
          <input-field
            type="time"
            :placeholder="$t('To')"
            v-model="toTime"
            :errors="toTime_errorsIfTouched"
          />
        </span>
      </div>

      <div class="buttons-bar">
        <button
          v-if="isExist"
          class="button is-outlined"
          @click="moveUp"
          :disabled="!showUp"
        >
          <span class="icon is-small"> <i class="fa fa-arrow-up"></i></span>
        </button>
        <button
          v-if="isExist"
          class="button is-outlined"
          @click="moveDown"
          :disabled="!showDown"
        >
          <span class="icon is-small"> <i class="fa fa-arrow-down"></i></span>
        </button>
        <span class="is-pulled-right">
          <button
            class="button is-outlined is-primary"
            @click="saveHour"
            :disabled="!group_valid || !group_dirty"
          >
            {{ isExist ? $t("Save") : $t("Add") }}
          </button>
          <button
            v-if="isExist"
            class="button is-danger is-outlined"
            @click="deleteHour"
          >
            {{ $t("Remove") }}
          </button>
        </span>
      </div>
      <div class="is-clearfix" />
      <field-message :success="$t(successMsg)" :failure="$t(failureMsg)" />
    </td>
  </tr>
</template>

<script>
import { InputField, FieldMessage } from "@/components/form"
import {
  validator,
  required,
  size,
  nonEmpty,
  customValidation
} from "@/validator"

export default {
  name: "hours-row",
  props: ["hour", "failureMsg", "successMsg", "showUp", "showDown"],
  mixins: [validator],
  components: {
    InputField,
    FieldMessage
  },
  data() {
    return {
      text: "",
      fromTime: "",
      toTime: ""
    }
  },
  watch: {
    hour: {
      immediate: true,
      handler(hour) {
        this.text_reset(this.$t(hour.text))
        this.fromTime_reset(hour.schedule.from)
        this.toTime_reset(hour.schedule.to)
      }
    }
  },
  validations: {
    text: [required, size(3, 32), nonEmpty],
    fromTime: [
      required,
      customValidation(function() {
        if (this.fromTime > this.toTime) {
          return "The start time must preceed end time"
        }
      })
    ],
    toTime: [
      required,
      customValidation(function() {
        if (this.fromTime > this.toTime) {
          return "The start time must preceed end time"
        }
      })
    ]
  },
  computed: {
    isExist() {
      return this.hour.id != null
    }
  },
  methods: {
    textChanged() {
      return this.hour.id == undefined || this.text != this.$t(this.hour.text)
    },
    saveHour() {
      const toBeSaved = {
        ...this.hour,
        text: this.textChanged() ? "~" + this.text : this.hour.text,
        schedule: {
          from: this.fromTime,
          to: this.toTime
        }
      }
      this.$emit("saveHour", toBeSaved)
    },
    deleteHour() {
      this.$emit("deleteHour")
    },
    moveUp() {
      this.$emit("moveUp")
    },
    moveDown() {
      this.$emit("moveDown")
    }
  }
}
</script>

<style lang="scss">
.inputs-bar {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .time-name {
    flex: 1;
    min-width: 12rem;
    padding: 0.17rem;
    width: 100%;
  }
  .time-range {
    display: inline-flex;
    margin-bottom: 0.17rem;
    justify-content: space-between;
    flex: 1;
    > * {
      flex: 1;
      padding: 0.17rem;
    }
  }
}
.buttons-bar {
  button {
    margin: 0.17rem;
  }
}
tr.hours-row:last-child td {
  border: none;
}
</style>
